var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#AAABAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3066 55.6001V57.5501C30.3066 59.1016 30.9915 60.5896 32.2104 61.6867C33.4294 62.7838 35.0827 63.4001 36.8066 63.4001C38.5305 63.4001 40.1838 62.7838 41.4028 61.6867C42.6218 60.5896 43.3066 59.1016 43.3066 57.5501V55.6001",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3066 55.6001V57.5501C30.3066 59.1016 30.9915 60.5896 32.2104 61.6867C33.4294 62.7838 35.0827 63.4001 36.8066 63.4001C38.5305 63.4001 40.1838 62.7838 41.4028 61.6867C42.6218 60.5896 43.3066 59.1016 43.3066 57.5501V55.6001",
    stroke: "#AAABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4 16.6C33.749 16.6 31.6 18.749 31.6 21.4V22.3636C25.5931 24.097 21.2 29.6358 21.2 36.2008V47.8008H19.9C17.7461 47.8008 16 49.5469 16 51.7008C16 53.8547 17.7461 55.6008 19.9 55.6008H53.7C55.8539 55.6008 57.6 53.8547 57.6 51.7008C57.6 49.5469 55.8539 47.8008 53.7 47.8008H52.4V36.2008C52.4 29.6358 48.0069 24.097 42 22.3636V21.4C42 18.749 39.851 16.6 37.2 16.6H36.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6 22.3636L32.0159 23.8048C32.6579 23.6195 33.1 23.0319 33.1 22.3636H31.6ZM21.2 47.8008V49.3008C22.0284 49.3008 22.7 48.6292 22.7 47.8008H21.2ZM52.4 47.8008H50.9C50.9 48.6292 51.5716 49.3008 52.4 49.3008V47.8008ZM42 22.3636H40.5C40.5 23.0319 40.9421 23.6195 41.5841 23.8048L42 22.3636ZM31.6 21.4H33.1C33.1 19.5775 34.5775 18.1 36.4 18.1V16.6V15.1C32.9206 15.1 30.1 17.9206 30.1 21.4H31.6ZM31.6 22.3636H33.1V21.4H31.6H30.1V22.3636H31.6ZM31.6 22.3636L31.1841 20.9224C24.5525 22.8361 19.7 28.9498 19.7 36.2008H21.2H22.7C22.7 30.3219 26.6338 25.3579 32.0159 23.8048L31.6 22.3636ZM21.2 36.2008H19.7V47.8008H21.2H22.7V36.2008H21.2ZM21.2 47.8008V46.3008H19.9V47.8008V49.3008H21.2V47.8008ZM19.9 47.8008V46.3008C16.9177 46.3008 14.5 48.7184 14.5 51.7008H16H17.5C17.5 50.3753 18.5745 49.3008 19.9 49.3008V47.8008ZM16 51.7008H14.5C14.5 54.6831 16.9177 57.1008 19.9 57.1008V55.6008V54.1008C18.5745 54.1008 17.5 53.0263 17.5 51.7008H16ZM19.9 55.6008V57.1008H53.7V55.6008V54.1008H19.9V55.6008ZM53.7 55.6008V57.1008C56.6823 57.1008 59.1 54.6831 59.1 51.7008H57.6H56.1C56.1 53.0263 55.0255 54.1008 53.7 54.1008V55.6008ZM57.6 51.7008H59.1C59.1 48.7184 56.6823 46.3008 53.7 46.3008V47.8008V49.3008C55.0255 49.3008 56.1 50.3753 56.1 51.7008H57.6ZM53.7 47.8008V46.3008H52.4V47.8008V49.3008H53.7V47.8008ZM52.4 47.8008H53.9V36.2008H52.4H50.9V47.8008H52.4ZM52.4 36.2008H53.9C53.9 28.9498 49.0475 22.8361 42.4159 20.9224L42 22.3636L41.5841 23.8048C46.9662 25.3579 50.9 30.3219 50.9 36.2008H52.4ZM42 21.4H40.5V22.3636H42H43.5V21.4H42ZM37.2 16.6V18.1C39.0225 18.1 40.5 19.5775 40.5 21.4H42H43.5C43.5 17.9206 40.6794 15.1 37.2 15.1V16.6ZM36.4 16.6V18.1H37.2V16.6V15.1H36.4V16.6Z",
    fill: "#AAABAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.3027,
    y: 16.3,
    width: 25.8,
    height: 25.8,
    rx: 12.9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3027,
    y: 16.3,
    width: 25.8,
    height: 25.8,
    rx: 12.9,
    stroke: "#AAABAB",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77917_69669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6006 29.2L49.6006 33.1999L57.6006 25.2",
    stroke: "#AAABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77917_69669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(41.6025 19.6001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty);
export default __webpack_public_path__ + "static/media/notifications-empty.297005ced7f81c7640cd7af8a86783fb.svg";
export { ForwardRef as ReactComponent };